// import { menuFunctions } from '../../02-molecules/menu/menu.behavior';

function setUpHeader() {
  const siteHeader = document.getElementById('site-header');
  const siteAdjuster = document.getElementById('site-header-adjuster');
  if (!siteAdjuster) return;
  siteAdjuster.setAttribute('style', `height:${siteHeader.offsetHeight}px`);
}

(function (Drupal, once) {
  Drupal.behaviors.header = {
    attach(context) {
      const elements = once('init', '#site-header', context);
      elements.forEach(setUpHeader);
    }
  };
}(Drupal, once));
